import { useSizeProp } from '@bigin/hooks'
import { buildProps } from '@bigin/utils'
import type { ExtractPropTypes } from 'vue'
import type Jumper from './jumper.vue'

export const jumperProps = buildProps({
  size: useSizeProp,
} as const)

export type JumperProps = ExtractPropTypes<typeof jumperProps>

export type JumperInstance = InstanceType<typeof Jumper>
